import React from 'react';

import { ArrowRightIcon } from '$partials/icon';
import { Button } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/listings').PartnershipCtaBox}
 */
const PartnershipCtaBox = ({
    topLabel,
    heading,
    ctaPage,
    ctaLabel,
    size
}) => {

    return (
        <article className={`${size === 'large' ? 'md-flex-row' : 'md-col-9 md-justify-between md-pt0'} md-height-100 flex flex-col col-12 green pt6`}>
            <div className={`${size === 'large' ? 'md-col-4' : 'md-col-12'} pt3 md-pt0 flex flex-col md-flex-row md-justify-between`}>
                <p className='type-style-5 pb4'>
                    Discover
                </p>
                {size === 'small' && topLabel && (
                    <p className='type-style-5 col-4'>
                        {topLabel}
                    </p>
                )}
            </div>
            <div className={`${size === 'large' ? 'md-col-7 md-flex md-flex-col md-justify-between md-height-100 md-pb8' : 'md-pb10'}`}>
                {size === 'large' && topLabel && (
                    <p className='type-style-5 col-4'>
                        {topLabel}
                    </p>
                )}
                <div>
                    <h3 className='type-style-1 sans-serif mt12 md-mt8'>
                        {heading}
                    </h3>
                    {ctaPage && ctaLabel && (
                        <Button
                            as='a'
                            className='bg-none type-style-5 link-reset mb3 md-mb0'
                            href={ctaPage.url}
                            iconClassName='bg-green white button border-radius-100px p3 md-p5'
                            look='underline'
                            renderIcon={<ArrowRightIcon />}>
                            {ctaLabel}
                        </Button>
                    )}
                </div>
            </div>
        </article>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PartnershipCtaBox;
